import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=1ec46238&scoped=true"
import script from "./BookDetails.vue?vue&type=script&lang=js"
export * from "./BookDetails.vue?vue&type=script&lang=js"
import style0 from "./BookDetails.vue?vue&type=style&index=0&id=1ec46238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec46238",
  null
  
)

export default component.exports